/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MaintenanceChartDataPoint
 */
export interface MaintenanceChartDataPoint {
    /**
     * 
     * @type {Date}
     * @memberof MaintenanceChartDataPoint
     */
    bucket: Date;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceChartDataPoint
     */
    predicted: boolean;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceChartDataPoint
     */
    count: number;
}

/**
 * Check if a given object implements the MaintenanceChartDataPoint interface.
 */
export function instanceOfMaintenanceChartDataPoint(value: object): value is MaintenanceChartDataPoint {
    if (!('bucket' in value) || value['bucket'] === undefined) return false;
    if (!('predicted' in value) || value['predicted'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function MaintenanceChartDataPointFromJSON(json: any): MaintenanceChartDataPoint {
    return MaintenanceChartDataPointFromJSONTyped(json, false);
}

export function MaintenanceChartDataPointFromJSONTyped(json: any, ignoreDiscriminator: boolean): MaintenanceChartDataPoint {
    if (json == null) {
        return json;
    }
    return {
        
        'bucket': (new Date(json['bucket'])),
        'predicted': json['predicted'],
        'count': json['count'],
    };
}

export function MaintenanceChartDataPointToJSON(json: any): MaintenanceChartDataPoint {
    return MaintenanceChartDataPointToJSONTyped(json, false);
}

export function MaintenanceChartDataPointToJSONTyped(value?: MaintenanceChartDataPoint | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'bucket': value['bucket'].toISOString(),
        'predicted': value['predicted'],
        'count': value['count'],
    };
}

